import React from 'react';

import {GridCard} from 'src/components/editorial';

import {SanityEditorialHomeIconGrid} from 'types/generated';

export const HomeIconGrid: React.FC<SanityEditorialHomeIconGrid> = ({heading, intro, gridItem}) => {
  const Articles = gridItem?.map(item => {
    return (
      <GridCard
        cardColClasses={'icons-card-ctn w-full sm:col-span-2 md:col-span-3 items-center'}
        title={item?.iconArticle?.title}
        category={item?.iconArticle?.editorialCategory?.title || ' '}
        image={item?.image}
        imageClasses={'grid w-auto h-[180px] sm:w-full sm:h-full mr-4 sm:mr-0 aspect-[3/4]'}
        contentClasses={'sm:col-span-full sm:mt-4 lg:mt-7'}
        titleClasses={'type-theta text-green-dark'}
        slug={item?.iconArticle?.slug?.current ?? ''}
        key={item?._key}
        eyebrowClasses={'block type-eyebrow mb-2 text-green-dark'}
        editorialCategory={item?.iconArticle?.editorialCategory}
        isPodcast={false}
      />
    );
  });
  return (
    <section className="px-gutter bg-ivory text-black module-spacing" data-module="chief-icons">
      <div className="wrapper-default w-full justify-center">
        <div className="w-full flex justify-center type-beta text-green-dark mb-[18px]">{heading}</div>
        <p className="w-full flex m-auto text-center type-sm-p text-gray max-w-[631px] mb-10 lg:mb-[4.25rem]">
          {intro}
        </p>
        <div className="w-full m-auto grid col-span-full sm:grid-cols-4 md:grid-cols-12 sm:gap-[26px] items-start">
          {Articles}
        </div>
      </div>
    </section>
  );
};
